/* ============================================================
   Plain storage for the client core — localStorage, behind the async
   KeyValueStorage shape. The snapshot, the outbox and the caches are one JSON
   blob per key, and a personal account's snapshot is far below localStorage's
   ~5 MB quota. If one ever approaches it, the move is IndexedDB behind this
   same interface — nothing above it changes. The core tolerates a throw
   (private mode, blocked storage), so none is caught here.
   ============================================================ */
import type { KeyValueStorage } from '@habishine/client-core';

export const storage: KeyValueStorage = {
  async getItem(key) {
    return localStorage.getItem(key);
  },
  async setItem(key, value) {
    localStorage.setItem(key, value);
  },
  async removeItem(key) {
    localStorage.removeItem(key);
  },
};
